<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 18 21">
    <g clip-path="url(#clip0_6892_9042)">
      <path
        d="M16.334 7.80628L15.0035 9.03543L13.9985 8.10703L15.329 6.87789C16.7162 5.60952 16.7162 3.53044 15.329 2.249C13.9419 0.967555 11.7054 0.967555 10.3324 2.249L6.10006 6.15871C4.72704 7.42708 4.72704 9.50616 6.10006 10.7745C7.47309 12.0429 9.72371 12.056 11.1109 10.7745L12.1159 11.7029C11.1534 12.5921 9.87941 13.0367 8.61963 13.0367C7.35985 13.0367 6.08591 12.5921 5.12338 11.7029C3.19831 9.92459 3.19831 7.00865 5.12338 5.23032L9.35568 1.32061C11.2807 -0.470801 14.4231 -0.470801 16.3623 1.32061C18.2874 3.09894 18.2874 6.0018 16.3623 7.79321L16.334 7.80628ZM6.51055 9.23157L6.32654 9.40155L7.31738 10.3299L7.5014 10.16C8.87442 8.89159 11.125 8.89159 12.5122 10.16C13.8852 11.4283 13.8994 13.5074 12.5122 14.7758L8.23745 18.7378C6.86443 20.0192 4.6138 20.0192 3.22662 18.7378C1.83945 17.4563 1.83945 15.3903 3.22662 14.122L4.72704 12.7359L3.72204 11.8075L2.22163 13.1936C0.296566 14.9719 0.296566 17.8879 2.22163 19.6662C3.18416 20.5554 4.4581 20.9999 5.71788 20.9999C6.97767 20.9999 8.2516 20.5554 9.21414 19.6662L13.4889 15.7172C15.414 13.9389 15.414 11.023 13.4889 9.24464C11.5497 7.45323 8.40731 7.46631 6.48224 9.24464L6.51055 9.23157Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9042">
        <rect width="17" height="21" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
